const state = {
    games: null
};

const mutations = {
    setGames(state, games) {
        state.games = games;
    }
};

const actions = {
    // ACTIONS
    getAll(context) {
        return new Promise((resolve, reject) => {
            console.info('getAll');
            fetch('http://api.stadiafr.com/games')
                .then((response) => {
                    console.info(response);
                    if (response.ok) {
                        response.json().then(function(data) {
                            context.commit('setGames', data);
                            resolve(data);
                        });
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};